import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { borderRadius, display, fontWeight, textAlign } from '@mui/system';
import { thirdly4 } from 'styles/theme';
import { error } from 'styles/theme';
import { thirdly2 } from 'styles/theme';

export const GradesStyles = muiStyled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    '.divider': {
        height: 2,
        background: thirdly2,
        position: "relative",
        bottom: 1
    },
    '.classes': {
        display: "flex",
        justifyContent: "space-between"
    },
    '.class': {
        display: "flex",
        flexDirection: "column",
        padding: "10px 0px"
    },
    '.invalid-students-alert': {
        color: error,
        textAlign: "right",
        fontWeight: "bold"
    },
    '.class-details': {
        display: "flex",
        alignItems: "center",
        columnGap: 10,
        padding: "10px 0px"
    },
    '.class-header': {
        columnGap: 10,
        display: "flex",
        justifyContent: "space-between"
    },
    '.num-students': {
        display: "flex",
        alignItems: "center"
    }
}));

export const CreateSchoolStyles = muiStyled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    rowGap: 15,
    height: "100%",
    overflow: "auto",
    '.empty-class': {
        padding: "20px 0px",
        fontSize: "20px"
    },
    '.grades': {
        flexGrow: 1,
        overflow: "auto"
    },
    '.content': {
        overflow: "auto",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column"
    },
    '.actions': {
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        padding: 10,
        columnGap: 10
    },
    '.wrap-grades': {
        display: "flex",
        flexDirection: "column",
        rowGap: 10
    },
    '.section-fields': {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: 15,
        width: "600px",
        [theme.breakpoints.down('lg')]: {
            width: "100%",
        },
    },
    '.grade': {
        display: "flex",
        columnGap: 10
    },
    '.section-title': {
        fontWeight: "bold",
        display: "flex",
        columnGap: 5,
        alignItems: "center"
    },
    '.form-content': {
        background: "white",
        padding: 20,
        display: "flex",
        flexDirection: "column",
        rowGap: 15,
        borderRadius: 15,
        flexGrow: 1,
        // overflow: "auto"
    },
    '.edit-button-active': {
        '.MuiButtonBase-root.MuiIconButton-root': {
            background: thirdly2,
            border: `1px solid ${thirdly2}`
        }
    },
    '.edit-button': {
        '.MuiButtonBase-root.MuiIconButton-root': {
            background: thirdly4,
            border: `1px solid ${thirdly2}`
        }
    },
    '.disabled': {
        pointerEvents: "none",
        opacity: 0.7
    },
    '.form-fields': {
        display: "flex",
        flexDirection: "column",
        rowGap: 15,
        flexGrow: 1
    }
}))


export const HeaderButtonsStyles = muiStyled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    'path': {
        fill: "white"
    }
}))

export const RolesCellStyles = muiStyled(Box)(({ theme }) => ({
    display: "flex",
    columnGap: 8
}))


export const AffiliationTeamStyles = muiStyled(Box)(({ theme }) => ({
    flexGrow: 1,
    overflow: "auto",
    '.role-chip': {
        display: "flex"
    }
}))

